export enum customerCategoryEnum {
  Catering = "CATERING",
  Hotel = "HOTEL",
  Restaurant = "RESTAURANT",
  Chain_Store = "CHAIN_STORE",
  Governmental = "GOVERNMENTAL",
  Fast_Food = "FAST_FOOD",
  Charity = "CHARITY",
  Butcher = "BUTCHER",
  Wholesaler = "WHOLESALER",
  Fellow = "FELLOW",
  Kebab = "KEBAB",
  Distributor = "DISTRIBUTOR",
  Hospital = "HOSPITAL",
  Factory = "FACTORY",
}
